export const SHOW_LOGIN = "AUTH_SHOW_LOGIN";
export const CHECK_LOGIN = "AUTH_CHECK_LOGIN";
export const CHECK_LOGGED_IN = "AUTH_CHECK_LOGGED_IN";
export const LOGIN_OR_REDIRECT = "AUTH_LOGIN_OR_REDIRECT";
export const LOGIN = {
  SUCCESS: "AUTH_LOGIN_SUCCESS",
  FAILED: "AUTH_LOGIN_FAILED"
}
export const LOGOUT = {
  LOGOUT: "AUTH_LOGOUT",
  SUCCESS: "AUTH_LOGOUT_SUCCESS",
  FAILED: "AUTH_LOGOUT_FAILED"
}

export function checkLoggedIn() {
  return {
    type: CHECK_LOGGED_IN
  }
}

export function loginOrRedirect(pathname) {
  return {
    type: LOGIN_OR_REDIRECT,
    pathname
  }
}

export function showLogin() {
  return {
    type: SHOW_LOGIN
  }
}

export function checkLogin(hash) {
  return {
    type: CHECK_LOGIN,
    hash
  }
}

export function loginSuccess(scopes = [], userMetadata = {}) {
  return {
    type: LOGIN.SUCCESS,
    scopes,
    userMetadata,
  }
}

export function loginFailed() {
  return {
    type: LOGIN.FAILED
  }
}

export function logout() {
  return {
    type: LOGOUT.LOGOUT
  }
}
export function logoutSuccess() {
  return {
    type: LOGOUT.SUCCESS
  }
}
export function logoutFailed() {
  return {
    type: LOGOUT.SUCCESS
  }
}